import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

import { Dialog } from '../others/Dialog';
export const LocationDeniedModal = ({ openDialog, onClose, errorMessage }) => {
    const handleReload = () => {
        window.location.reload();
        onClose();
    };

    return (
        <Dialog
            openDialog={openDialog}
            widthDialog="sm"
            styleDialog={{
                backgroundColor: 'rgba(0, 0, 0, 0.6)',
                borderRadius: '8px',
                boxShadow: 0,
                backdropFilter: 'blur(5px)'
            }}
            title="Permiso requerido"
            styleTitle={{
                color: 'white',
                fontWeight: 'bold',
                fontSize: '20px',
                textAlign: 'center',
            }}
            content={
                <div style={{ textAlign: 'center' }}>
                    <Typography variant="body1" color="white" sx={{ mb: 1 }}>
                        {errorMessage || "Debes permitir el acceso a tu ubicación para continuar."}
                    </Typography>
                    <Typography variant="body2" color="white" sx={{ opacity: 0.8 }}>
                        Vuelve a intentarlo y acepta el permiso cuando el navegador lo solicite.
                    </Typography>
                </div>
            }
            styleContent={{ padding: '16px 24px' }}
            actions={
                <Button
                    variant="contained"
                    color="primary"
                    sx={{ px: 4 }}
                    onClick={handleReload} 
                >
                    Aceptar
                </Button>
            }
            styleActions={{ justifyContent: 'center', pb: 2 }}
            openLoadingOverlay={false}
            onClose={() => {}}
        />
    );
};
